import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { PanelUserMachineStyle } from '../../../UserMachine/PanelUserMachineStyle';
import { Button, CircularProgress, Grid, Paper, Table, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { consultaResultadosEncuesta, consultaValTelAndIMC } from '../../../domain/api/UsersApi';
import { BiSearch } from "react-icons/bi";
import theme from '../../../../app/config/themaConfig';
import ListValidaciones from './ListValidaciones';
import ListResultados from './ListResultadosPoll';


export const ValidacionDeCitas = (props) => {
    const classes = PanelUserMachineStyle();
  
    const [UsersMachine, setUsersMachine] = useState([]);
    const [Resultados, setResultados] = useState([]);

    const [isLoadUser, setISloaduser] = useState(false);
    const [MensajeError, setMensajeError] = useState(null);

    const [busqueda, setBusqueda] = useState("")
    let { id } = useParams();

    const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 7 : id;

    const reload = async (idBascula, page, rowsPerPage, busqueda) => {

        const usuarios = await consultaValTelAndIMC(busqueda);

        const resultadosEncuesta = await consultaResultadosEncuesta(busqueda);

        try {

            setUsersMachine(usuarios?.respuesta ? usuarios.respuesta : [])
            setResultados(resultadosEncuesta.respuesta[0].respuestasUsuario)

            if (usuarios?.mensaje === "No existe usuario con ese numero de telefono") {
                setMensajeError(usuarios.mensaje);
                setISloaduser(false)
            } else {
                setMensajeError(null); // Limpiar mensaje de error si no es el caso
                setISloaduser(false)
            }

        } catch (err) {
            console.log("Este es el error", err)
        }
    }

    const filtrar = () => {
        reload(idBascula, 0, 10, busqueda);
        setISloaduser(true)
    };


    const buscador = (e) => {
        setBusqueda(e.target.value, "esta es la busqueda")

    }
  
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };
    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Validacion de citas"
                    to="/"
                    namePage2="Datos"
                    to2="/Datos"

                >
                    Home
                </MigaPan>
            </Grid>
            <Paper className={classes.paper} style={{ width: "100%", borderRadius: "15px" }} >
                <Grid item xs={12}>
                    <Grid container >

                        <Grid item xs={6} className={classes.searchContainer} style={{ marginLeft: '15%' }} >
                            <div className={classes.searchInputContainer}>
                                <input
                                    id="descripcion"
                                    type="buscador"
                                    name="descripcion"
                                    onChange={buscador}
                                    value={busqueda}
                                    onKeyPress={handleKeyPress}
                                    className={classes.searchInput}
                                    placeholder="Buscar por telefono"
                                    style={{
                                        border: `1px solid ${theme.palette.primary.main}`,
                                        borderRadius: '20px 0px 0px 20px',
                                        padding: '4px 8px',
                                        fontSize: 'inherit',
                                        outline: 'none',
                                        flex: 1,
                                    }}
                                />
                            </div>
                            <Button onClick={filtrar} className={classes.searchButton} style={{ backgroundColor: theme.palette.primary.main }}>
                                <BiSearch />
                            </Button>
                        </Grid>
                        {isLoadUser ? (

                            <CircularProgress style={{ marginLeft: '50%' }} />

                        ) : UsersMachine.length !== 0 || Resultados.length ? (
                            <>
                                <Grid item xs={12}>
                                    <Table>
                                        <TableHead color='primary'>
                                            <TableRow color='primary'>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '1%', width: '16%', color: primaryColor }}>Nombre</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '4%', width: '16%', color: primaryColor }}>Celular</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '16%', color: primaryColor }}>Documento</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '16%', color: primaryColor }}>Email</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '18%', color: primaryColor }}>Fecha de Nacimiento</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '0%', width: '16%', color: primaryColor }}>Edad</TableCell>

                                            </TableRow>
                                        </TableHead>
                                    </Table>
                                </Grid>
                                <Grid item xs={12}>
                                    <ListValidaciones
                                        rows={UsersMachine}
                                        isLoadUser={isLoadUser}
                                    />
                                </Grid>
                                <Typography style={{ fontWeight: 'bold', fontSize: "20px", marginLeft: '40%' }} color='primary' >
                                    Resultado Encuesta
                                </Typography>
                                <Grid item xs={10} style={{ marginLeft: '8%' }}>
                                    <Table>
                                        <TableHead color='primary'>
                                            <TableRow color='primary'>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '20%', width: '16%', color: primaryColor }}>Pregunta</TableCell>
                                                <TableCell className={classes.TableCell} style={{ paddingLeft: '20%', width: '16%', color: primaryColor }}>Respuesta</TableCell>
                                            </TableRow>
                                        </TableHead>
                                    </Table>
                                </Grid>
                                <ListResultados
                                    rows={Resultados}

                                />
                            </>
                        ) : MensajeError ? (
                            <Grid item xs={12}>
                                <Paper className={classes.card}>
                                    <Typography variant="body1" style={{ padding: '1%' }}>No se encuentran resultados para este documento, es necesario pasar por una estación de medición para registrarse</Typography>
                                </Paper>
                            </Grid>
                        ) : null}
                    </Grid>

                </Grid>
                {MensajeError === null && isLoadUser === false && UsersMachine.length === 0 && (
                    <Grid item xs={12}>
                        <Typography variant="body1" style={{ padding: '1%', textAlign: 'center' }}>Ingresa el telefono del usuario para buscarlo en el sistema</Typography>
                    </Grid>
                )}
            </Paper>
        </>
    );

}    